<template>

	<main id="operations">

		<section class="operations-hero">

			<div class="limit-width">

				<div class="operations-hero__content">

					<span>
						{{ 'operations_page_landing' | staticContentAlt }}
					</span>

					<h1>
						{{ 'operations_page_landing' | staticTitle }}
					</h1>

					<vue-marked>
						{{ 'operations_page_landing' | staticContent }}
					</vue-marked>

					<a href="#" class="btn-primary">
						{{ 'operations_page_landing_cta' | staticTitle }}
					</a>

				</div>

				<div class="operations-hero__image">

					<img
						:src="'operations_page_landing' | staticImg"
						alt=""
					>

				</div>

			</div>

		</section>


		<section class="operations-blueprint">

			<div class="limit-width">

				<h2>
					{{ 'operations_page_blueprint' | staticTitle }}
				</h2>

				<vue-marked>
					{{ 'operations_page_blueprint' | staticContent }}
				</vue-marked>

			</div>

		</section>


		<section class="operations-architecture">

			<div class="limit-width">

				<div class="operations-architecture__intro">

					<span>
						{{ 'operations_page_architecture' | staticContentAlt }}
					</span>

					<h2>
						{{ 'operations_page_architecture' | staticTitle }}
					</h2>

					<vue-marked>
						{{ 'operations_page_architecture' | staticContent }}
					</vue-marked>

				</div>

				<div class="operations-architecture__grid">

					<article
						v-for="item in capabilities"
						:key="item"
						class="operations-capability"
					>

						<span>
							{{ item | staticContentAlt }}
						</span>

						<h3>
							{{ item | staticTitle }}
						</h3>

						<vue-marked>
							{{ item | staticContent }}
						</vue-marked>

					</article>

				</div>

			</div>

		</section>


		<section class="operations-build">

			<div class="limit-width">

				<div class="operations-build__intro">

					<span>
						{{ 'operations_page_build' | staticContentAlt }}
					</span>

					<h2>
						{{ 'operations_page_build' | staticTitle }}
					</h2>

					<vue-marked>
						{{ 'operations_page_build' | staticContent }}
					</vue-marked>

				</div>

				<div class="operations-build__grid">

					<article
						v-for="item in buildItems"
						:key="item"
					>

						<h3>
							{{ item | staticTitle }}
						</h3>

						<vue-marked>
							{{ item | staticContent }}
						</vue-marked>

					</article>

				</div>

				<div class="operations-build__statement">

					<vue-marked>
						{{ 'operations_page_build_statement' | staticContent }}
					</vue-marked>

				</div>

			</div>

		</section>


		<section class="operations-model">

			<div class="limit-width">

				<div class="operations-model__intro">

					<span>
						{{ 'operations_page_model' | staticContentAlt }}
					</span>

					<h2>
						{{ 'operations_page_model' | staticTitle }}
					</h2>

					<vue-marked>
						{{ 'operations_page_model' | staticContent }}
					</vue-marked>

				</div>

				<div class="operations-model__steps">

					<article
						v-for="item in modelItems"
						:key="item"
					>

						<h3>
							{{ item | staticTitle }}
						</h3>

						<vue-marked>
							{{ item | staticContent }}
						</vue-marked>

					</article>

				</div>

				<div class="operations-model__statement">

					<vue-marked>
						{{ 'operations_page_model_statement' | staticContent }}
					</vue-marked>

				</div>

			</div>

		</section>


		<section class="operations-network">

			<div class="limit-width">

				<span>
					{{ 'operations_page_network' | staticContentAlt }}
				</span>

				<h2>
					{{ 'operations_page_network' | staticTitle }}
				</h2>

				<vue-marked>
					{{ 'operations_page_network' | staticContent }}
				</vue-marked>

			</div>

		</section>


		<section class="operations-strategy">

			<div class="limit-width">

				<div class="operations-strategy__content">

					<span>
						{{ 'operations_page_strategy' | staticContentAlt }}
					</span>

					<h2>
						{{ 'operations_page_strategy' | staticTitle }}
					</h2>

					<vue-marked>
						{{ 'operations_page_strategy' | staticContent }}
					</vue-marked>

				</div>

			</div>

		</section>


		<section class="operations-capital">

			<div class="limit-width">

				<div class="operations-capital__content">

					<span>
						{{ 'operations_page_capital' | staticContentAlt }}
					</span>

					<h2>
						{{ 'operations_page_capital' | staticTitle }}
					</h2>

					<vue-marked>
						{{ 'operations_page_capital' | staticContent }}
					</vue-marked>

					<a href="#" class="btn-primary">
						{{ 'operations_page_capital_cta' | staticTitle }}
					</a>

				</div>

			</div>

		</section>


		<section class="operations-who">

			<div class="limit-width">

				<div class="operations-who__intro">

					<span>
						{{ 'operations_page_who' | staticContentAlt }}
					</span>

					<h2>
						{{ 'operations_page_who' | staticTitle }}
					</h2>

					<vue-marked>
						{{ 'operations_page_who' | staticContent }}
					</vue-marked>

				</div>

				<div class="operations-who__grid">

					<article
						v-for="item in whoItems"
						:key="item"
					>

						<vue-marked>
							{{ item | staticContent }}
						</vue-marked>

					</article>

				</div>

			</div>

		</section>


		<section class="operations-final-cta">

			<div class="limit-width">

				<div class="operations-final-cta__content">

					<h2>
						{{ 'operations_page_final_cta' | staticTitle }}
					</h2>

					<vue-marked>
						{{ 'operations_page_final_cta' | staticContent }}
					</vue-marked>

				</div>

				<div class="operations-final-cta__actions">

					<a href="#" class="btn-primary">
						{{ 'operations_page_final_cta_primary' | staticTitle }}
					</a>

					<a href="#" class="project__link">
						{{ 'operations_page_final_cta_secondary' | staticTitle }}
					</a>

				</div>

			</div>

		</section>

	</main>

</template>


<script>
export default {

	name: 'Operations',

	data() {

		return {

			capabilities: [
				'operations_page_capability_1',
				'operations_page_capability_2',
				'operations_page_capability_3',
				'operations_page_capability_4',
				'operations_page_capability_5',
				'operations_page_capability_6'
			],

			buildItems: [
				'operations_page_build_item_1',
				'operations_page_build_item_2',
				'operations_page_build_item_3',
				'operations_page_build_item_4'
			],

			modelItems: [
				'operations_page_model_item_1',
				'operations_page_model_item_2',
				'operations_page_model_item_3',
				'operations_page_model_item_4',
				'operations_page_model_item_5',
				'operations_page_model_item_6'
			],

			whoItems: [
				'operations_page_who_item_1',
				'operations_page_who_item_2',
				'operations_page_who_item_3',
				'operations_page_who_item_4',
				'operations_page_who_item_5',
				'operations_page_who_item_6',
				'operations_page_who_item_7'
			]

		}

	}

}
</script>


<style lang="scss">

#operations {
	color: #394455;
	background: #F5F1EB;

	h1,
	h2,
	h3,
	p {
		margin-top: 0;
	}


	.operations-hero {
		padding: 48px 0;
		background: #F5F1EB;

		.limit-width {
			display: grid;
			grid-template-columns: 1fr;
			gap: 35px;
		}

		&__content {

			> span {
				display: block;
				margin-bottom: 12px;

				font-size: .72rem;
				font-weight: 600;
				letter-spacing: .14em;
				text-transform: uppercase;

				color: #D97943;
			}

			h1 {
				max-width: 760px;
				margin-bottom: 22px;

				font-family: "Cormorant Garamond", serif;
				font-size: 2.8rem;
				font-weight: 400;
				line-height: 1;

				color: #1F2B3D;
			}

			p {
				max-width: 680px;
				margin-bottom: 15px;

				font-size: .95rem;
				line-height: 1.75;
			}

			.btn-primary {
				display: inline-flex;
				margin-top: 18px;
			}
		}

		&__image {

			img {
				display: block;
				width: 100%;
				height: 420px;

				object-fit: cover;
			}
		}
	}


	.operations-blueprint {
		padding: 48px 0;
		background: #ECE8E0;

		.limit-width {
			display: grid;
			grid-template-columns: 1fr;
			gap: 24px;
		}

		h2 {
			margin-bottom: 0;

			font-family: "Cormorant Garamond", serif;
			font-size: 2.35rem;
			font-weight: 400;
			line-height: 1.05;

			color: #1F2B3D;
		}

		p {
			max-width: 820px;
			margin-bottom: 14px;

			font-size: .95rem;
			line-height: 1.75;
		}
	}


	.operations-architecture {
		padding: 48px 0;
		background: #F5F1EB;

		&__intro {
			max-width: 820px;
			margin-bottom: 32px;

			> span {
				display: block;
				margin-bottom: 10px;

				font-size: .72rem;
				font-weight: 600;
				letter-spacing: .14em;
				text-transform: uppercase;

				color: #D97943;
			}

			h2 {
				margin-bottom: 18px;

				font-family: "Cormorant Garamond", serif;
				font-size: 2.35rem;
				font-weight: 400;
				line-height: 1.05;

				color: #1F2B3D;
			}

			p {
				font-size: .95rem;
				line-height: 1.75;
			}
		}

		&__grid {
			display: grid;
			grid-template-columns: 1fr;
			gap: 16px;
		}
	}


	.operations-capability {
		padding: 28px 24px;
		background: #ECE8E0;

		> span {
			display: block;
			margin-bottom: 12px;

			font-size: .7rem;
			font-weight: 600;
			letter-spacing: .14em;
			text-transform: uppercase;

			color: #B45D2D;
		}

		h3 {
			margin-bottom: 15px;

			font-family: "Cormorant Garamond", serif;
			font-size: 1.7rem;
			font-weight: 400;
			line-height: 1.08;

			color: #1F2B3D;
		}

		p,
		li {
			font-size: .9rem;
			line-height: 1.7;
		}

		ul {
			padding-left: 18px;
		}
	}


	.operations-build {
		padding: 48px 0;
		background: #1F2B3D;
		color: #fff;

		&__intro {
			max-width: 820px;
			margin-bottom: 32px;

			> span {
				display: block;
				margin-bottom: 10px;

				font-size: .72rem;
				font-weight: 600;
				letter-spacing: .14em;
				text-transform: uppercase;

				color: #D97943;
			}

			h2 {
				margin-bottom: 18px;

				font-family: "Cormorant Garamond", serif;
				font-size: 2.35rem;
				font-weight: 400;
				line-height: 1.05;

				color: #fff;
			}

			p {
				color: rgba(255,255,255,.72);
				font-size: .95rem;
				line-height: 1.75;
			}
		}

		&__grid {
			display: grid;
			grid-template-columns: 1fr;
			gap: 12px;
		}

		&__grid article {
			padding: 22px;

			background: rgba(255,255,255,.06);

			h3 {
				margin-bottom: 8px;

				font-family: "Cormorant Garamond", serif;
				font-size: 1.45rem;
				font-weight: 400;

				color: #fff;
			}

			p {
				margin: 0;

				font-size: .88rem;
				line-height: 1.65;

				color: rgba(255,255,255,.68);
			}
		}

		&__statement {
			max-width: 900px;
			margin-top: 32px;
			padding: 26px;

			background: rgba(255,255,255,.06);

			p {
				margin: 0;

				font-family: "Cormorant Garamond", serif;
				font-size: 1.5rem;
				line-height: 1.25;

				color: #fff;
			}
		}
	}


	.operations-model {
		padding: 48px 0;
		background: #ECE8E0;

		&__intro {
			max-width: 820px;
			margin-bottom: 30px;

			> span {
				display: block;
				margin-bottom: 10px;

				font-size: .72rem;
				font-weight: 600;
				letter-spacing: .14em;
				text-transform: uppercase;

				color: #D97943;
			}

			h2 {
				margin-bottom: 18px;

				font-family: "Cormorant Garamond", serif;
				font-size: 2.35rem;
				font-weight: 400;
				line-height: 1.05;

				color: #1F2B3D;
			}
		}

		&__steps {
			display: grid;
			grid-template-columns: 1fr;
			gap: 12px;
		}

		&__steps article {
			padding: 22px;

			background: #F5F1EB;

			h3 {
				margin-bottom: 8px;

				font-family: "Cormorant Garamond", serif;
				font-size: 1.45rem;
				font-weight: 400;

				color: #1F2B3D;
			}

			p {
				margin: 0;

				font-size: .88rem;
				line-height: 1.65;
			}
		}

		&__statement {
			max-width: 900px;
			margin-top: 30px;

			p {
				font-family: "Cormorant Garamond", serif;
				font-size: 1.45rem;
				line-height: 1.3;

				color: #1F2B3D;
			}
		}
	}


	.operations-network,
	.operations-strategy {
		padding: 48px 0;
		background: #F5F1EB;

		.limit-width {
			max-width: 980px;
		}

		span {
			display: block;
			margin-bottom: 10px;

			font-size: .72rem;
			font-weight: 600;
			letter-spacing: .14em;
			text-transform: uppercase;

			color: #D97943;
		}

		h2 {
			margin-bottom: 20px;

			font-family: "Cormorant Garamond", serif;
			font-size: 2.35rem;
			font-weight: 400;
			line-height: 1.05;

			color: #1F2B3D;
		}

		p {
			max-width: 900px;

			font-size: .95rem;
			line-height: 1.75;
		}
	}


	.operations-strategy {
		background: #ECE8E0;
	}


	.operations-capital {
		padding: 48px 0;
		background: #201B1C;
		color: #fff;

		&__content {
			max-width: 850px;

			> span {
				display: block;
				margin-bottom: 10px;

				font-size: .72rem;
				font-weight: 600;
				letter-spacing: .14em;
				text-transform: uppercase;

				color: #D97943;
			}

			h2 {
				margin-bottom: 18px;

				font-family: "Cormorant Garamond", serif;
				font-size: 2.35rem;
				font-weight: 400;
				line-height: 1.05;

				color: #fff;
			}

			p {
				font-size: .95rem;
				line-height: 1.75;

				color: rgba(255,255,255,.72);
			}

			.btn-primary {
				display: inline-flex;
				margin-top: 18px;
			}
		}
	}


	.operations-who {
		padding: 48px 0;
		background: #F5F1EB;

		&__intro {
			max-width: 820px;
			margin-bottom: 30px;

			> span {
				display: block;
				margin-bottom: 10px;

				font-size: .72rem;
				font-weight: 600;
				letter-spacing: .14em;
				text-transform: uppercase;

				color: #D97943;
			}

			h2 {
				margin-bottom: 18px;

				font-family: "Cormorant Garamond", serif;
				font-size: 2.35rem;
				font-weight: 400;
				line-height: 1.05;

				color: #1F2B3D;
			}
		}

		&__grid {
			display: grid;
			grid-template-columns: 1fr;
			gap: 12px;
		}

		&__grid article {
			padding: 20px 22px;
			background: #ECE8E0;

			p {
				margin: 0;

				font-size: .9rem;
				line-height: 1.65;
			}
		}
	}


	.operations-final-cta {
		padding: 48px 0;
		background: #1F2B3D;
		color: #fff;

		.limit-width {
			display: grid;
			grid-template-columns: 1fr;
			gap: 28px;
		}

		&__content {

			h2 {
				margin-bottom: 20px;

				font-family: "Cormorant Garamond", serif;
				font-size: 2.6rem;
				font-weight: 400;
				line-height: 1;

				color: #fff;
			}

			p {
				max-width: 760px;

				font-size: .95rem;
				line-height: 1.75;

				color: rgba(255,255,255,.72);
			}
		}

		&__actions {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			gap: 18px;
		}

		.project__link {
			color: #fff;
		}
	}
}


@media (min-width: 768px) {

	#operations {

		.operations-hero,
		.operations-blueprint,
		.operations-architecture,
		.operations-build,
		.operations-model,
		.operations-network,
		.operations-strategy,
		.operations-capital,
		.operations-who,
		.operations-final-cta {
			padding: 58px 0;
		}

		.operations-hero {

			&__content h1 {
				font-size: 3.7rem;
			}

			&__image img {
				height: 500px;
			}
		}

		.operations-architecture__grid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		.operations-build__grid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		.operations-model__steps {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		.operations-who__grid {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}

		.operations-final-cta__actions {
			flex-direction: row;
			align-items: center;
		}
	}
}


@media (min-width: 1100px) {

	#operations {

		.operations-hero,
		.operations-blueprint,
		.operations-architecture,
		.operations-build,
		.operations-model,
		.operations-network,
		.operations-strategy,
		.operations-capital,
		.operations-who,
		.operations-final-cta {
			padding: 68px 0;
		}

		.operations-hero {

			.limit-width {
				grid-template-columns:
					minmax(0, 1.05fr)
					minmax(380px, .95fr);

				gap: 75px;
				align-items: center;
			}

			&__content h1 {
				font-size: 4.5rem;
			}

			&__image img {
				height: 610px;
			}
		}

		.operations-blueprint {

			.limit-width {
				grid-template-columns:
					minmax(0, .75fr)
					minmax(0, 1.25fr);

				gap: 75px;
			}

			h2 {
				font-size: 3.3rem;
			}
		}

		.operations-architecture__intro h2,
		.operations-build__intro h2,
		.operations-model__intro h2,
		.operations-network h2,
		.operations-strategy h2,
		.operations-capital__content h2,
		.operations-who__intro h2 {
			font-size: 3.3rem;
		}

		.operations-capability {
			padding: 34px 32px;
		}

		.operations-build__grid {
			grid-template-columns: repeat(4, minmax(0, 1fr));
		}

		.operations-model__steps {
			grid-template-columns: repeat(6, minmax(0, 1fr));
		}

		.operations-who__grid {
			grid-template-columns: repeat(3, minmax(0, 1fr));
		}

		.operations-final-cta {

			.limit-width {
				grid-template-columns:
					minmax(0, 1.15fr)
					minmax(300px, .85fr);

				gap: 80px;
				align-items: center;
			}

			&__content h2 {
				font-size: 3.8rem;
			}

			&__actions {
				justify-content: flex-end;
			}
		}
	}
}

</style>